module.exports = __webpack_public_path__ + "static/media/vietnam.045c7469.svg";